/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import { Row } from 'react-bootstrap';

export const ProfileImage = styled(Image)`
  width: 90px;
  height: 90px;
  object-fit: contain;
  text-align: center;
  // border-radius: 20px;
`;

export const ImgCol = styled(Row)`
  @media (max-width: 480px) {
    text-align: center;
  }
  margin-left: 0.5rem;
`;
export const ImageCon = styled.div`
  border-radius: 0.5em;
  width: 100px;
  margin-top: 3%;
  margin-left: 3%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #fcfcfc;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  @media (max-width: 480px) {
    margin: 4% auto auto auto;
  }
`;
export const ImagesIcon: any = styled(Image)`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
